// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.

$(document).ready(function () {

    $('[data-toggle="tooltip"]').tooltip();


    $(window).scroll(function () {

        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            $('.header-logo a img').css("height", "3rem");
            $('.header').css("padding", "0");
        } else {
            $('.header-logo a img').css("height", "4rem");
            $('.header').css("padding", "1rem");
        }

    });

    // FLIP CARD FUNCTIONALITY

    $('.flip').click(function () {

        var card = $(this);

        if (card.hasClass('is-flipped')) {
            card.removeClass('is-flipped');
        } else {
            card.addClass('is-flipped');
        }
    })

    // RANGE SLIDER FUNCTIONALITY

    /*
     $('.slider').click(function () {
        var slider = $(this);
        var sliderColor = slider.next();
        var indicator = slider.parent().prev();
        var val = slider.val();
        var min = slider.attr('min'),
            max = slider.attr('max');
        var range = (max - min);
        var percent = (val / range);

        sliderColor.css("transform", "scale(" + percent + ", 1)");
        indicator.html(val + " Months");


    });
    */

    $('.range input').change(function () {
        var value = $(this).val();
        var indicator = $(this).parent().prev();

        indicator.html(value + " Months");

    });

    // PAGINATION FUNCTIONALITY

    $('.pagination-item .page-link').click(function () {

        var item = $(this).parent();

        item.siblings().each(function () {
            $(this).removeClass('active');
        });

        item.addClass('active');

    });

    $('.pagination-prev .page-link').click(function () {


        var prevLink = $(this).parent();
        var active = prevLink.siblings('.active');
        var order = parseInt(active.data('order'));
        var newOrder = (order - 1);

        prevLink.siblings().each(function () {

            var currentOrder = $(this).data('order');

            if (currentOrder == newOrder) {
                active.removeClass('active');
                $(this).addClass('active');
            }

        });

    });

    $('.pagination-next .page-link').click(function () {


        var nextLink = $(this).parent();
        var active = nextLink.siblings('.active');
        var order = parseInt(active.data('order'));
        var newOrder = (order + 1);

        nextLink.siblings().each(function () {

            var currentOrder = $(this).data('order');

            if (currentOrder == newOrder) {
                active.removeClass('active');
                $(this).addClass('active');
            }

        });

    });

    // BUTTON GROUP FUNCTIONALITY

    $('.btn-group .btn').click(function () {
        var btn = $(this);

        btn.siblings().removeClass('active');
        btn.addClass('active');
    });



    // MEGA MENU FUNCTIONALITY 

    $('.cm-menu > li').hover(function () {

        // clear any content in div
        $('#header-collapse').html("");

        var subNav = $(this).children('ul');

        if (subNav.length) { //if there is a subNav for this menu item

            subNav.clone().appendTo('#header-collapse');
            $('#header-collapse').css("display", "block");

        } else { // else hide mega menu and clear content 

            $('#header-collapse').html("").css("display", "none");

        }

    })

    $('.header').hover(function () {
        // do nothing on hover
    }, function () {
        //when hover off of header, collapse mega menu if open 
        $("#header-collapse").css("display", "none");
    });


    // // toggles team member bio over team member

    $(".team-member").click(function () {

        var bio = $(this).children('.team-member-bio');

        if (bio.hasClass('team-member-bio-up')) {
            bio.removeClass('team-member-bio-up').addClass('team-member-bio-down');
        } else {
            bio.removeClass('team-member-bio-down').addClass('team-member-bio-up');
        }

    });

    // Accordion Functionality
    $(".accordion-heading").click(function (e) {
        e.preventDefault();
        $(this).toggleClass('collapsed');
        //$(this).children('.fas').toggleClass('fa-chevron-up fa-chevron-down');
    });

    //Accordion Item
    $('.accordion-item').click(function (e) {
        /*e.preventDefault();*/

        $('.accordion-item.active') // all the open accordion-item
            .not(this).removeClass('active'); // remove the class
        $(this).toggleClass('active'); // set clicked to open
    });

    // Sidebar Toggle
    $('.sidebar-toggle').on('click', function () {
        $('#sidebar_container').toggleClass('hidden');
    });


    //Navbar Main Section Toggle in Tablet/Mobile
    //$('#navbar-main-toggle').on('click', function () {
    //    $('#navbar-main').toggleClass('show');
    //});

    // Nav Dropdown On Hover
    $('.navbar-nav li').hover(function () { // mouse-over
        var isHovered = $(this).is(':hover');
        if (isHovered) {
            $(this).children('ul').stop().addClass('open');
        } else {
            $(this).children('ul').stop().removeClass('open');
        }
    });

    //Adding ClassName Dropdown-Menu to UL's and Toggle-icon to links
    if (!$("#navbar-main ul").hasClass("class-name")) {
        $("#navbar-main .dropdown-menu ul").addClass("dropdown-menu");
    }

    var links = $('#navbar-main .hamburger-nav ul.dropdown-menu li a');

    jQuery.each(links, function (index, item) {
        if ($(item).next().is('ul')) {
            $(item).html();
            $(item).after('<a href="#" class="toggle-icon">&nbsp;</a>');
        }
    });

    // mobile Menu
    $(".toggle-icon").click(function () {
        var thisEle = $(this);
        var container = thisEle.closest(".hamburger-nav");
        var item = thisEle.closest(".sub");
        var content = item.find(".dropdown-menu");

        if (!$(this).hasClass("show")) {
            var parentList = $(this).parent().parent();
            $(parentList).prop("tagName");
            if (
                $(parentList).prop("tagName") == "UL" &&
                $(parentList).hasClass("dropdown-menu")
            ) {
                $(parentList)
                    .find("li")
                    .each(function () {
                        $(this).find("ul").removeClass("active");
                        $(this).find(".toggle-icon").removeClass("show");
                    });
            }
        }

        $(this).next(".dropdown-menu").toggleClass("active");
        $(this).toggleClass("show");
    });

    $('.hamburger-nav ul li a').click(function () {
        $('li a').removeClass('current');
        $(this).addClass('current');
    });

    $(function () {
        //Cycles through each of the mobile nav links 
        $('.hamburger-nav li a').each(function () {
            var href = $(this).attr('href') || '';
            function normalize(p) {
                if (!p) return '/';
                p = p.replace(/\/+$/, '');
                if (p === '') return '/';
                if (p === '/~') return '/';
                return p;
            }

            var normHref = normalize(href);
            var normLoc = normalize(window.location.pathname);

            if (normHref === normLoc) {
                // Add current class
                $(this).parent().addClass('is-current');
            }
        });
    });

    //Open Hamburger menu
    $('#navbar-main-toggle').on('click', function () {
        $('body').toggleClass('noscroll');
        $('.nav-overlay').toggleClass('active');
    });

    //Open overlay
    $(".nav-overlay").click(function () {
        $(this).removeClass('active');
        $('body').removeClass('noscroll');
        $('.navbar-main').removeClass('show');
    });

    //Close Hamburger Menu for Desktop
    $(window).on('resize', function () {
        var width = $(window).width();

        if (width >= 200 && width <= 1023) {
            $('.nav-overlay').removeClass('active');
            $('body').removeClass('noscroll');
            $('.navbar-main').removeClass('show');
        } else {
            $('.navbar-main').addClass('show');
        }
    })

    //Hamburger menu Close Button
    $('.close-hamburger-nav').on('click', function () {
        $('body').removeClass('noscroll');
        $('.nav-overlay').removeClass('active');
        $('.navbar-main').removeClass('show');
    });

    // Add active class to the current button (highlight it)
    // Make this resilient: ensure element exists and clear all active classes before adding to the clicked item.
    var header = document.getElementById("navbar-main");
    if (header) {
        var btns = header.getElementsByClassName("nav-item");
        for (var i = 0; i < btns.length; i++) {
            btns[i].addEventListener("click", function () {
                try {
                    var current = header.querySelectorAll('.nav-item.active');
                        current.forEach(function (c) { c.classList.remove('active'); });
                } catch (e) { /* ignore */ }
                this.classList.add('active');
            });
        }
    }

});

// Deep linking for tabs
$(document).ready(() => {
    let url = location.href.replace(/\/$/, "");

    if (location.hash) {
        const hash = url.split("#");
        $('#myTab a[href="#' + hash[1] + '"]').tab("show");
        url = location.href.replace(/\/#/, "#");
        history.replaceState(null, null, url);
        setTimeout(() => {
            $(window).scrollTop(0);
        }, 400);
    }

    $('a[data-toggle="tab"]').on("click", function () {
        let newUrl;
        const hash = $(this).attr("href");
        if (hash == "#overnight-tab") {
            newUrl = url.split("#")[0];
        } else {
            newUrl = url.split("#")[0] + hash;
        }
        newUrl += "/";
        history.replaceState(null, null, newUrl);
    });
});


$(document).ready(function () {
    $(".dropdown-toggle").dropdown();

    $('a.dropdown-toggle').click(function () {
        location.href = this.href;
    });
});

$(function () {
    $('[data-toggle="popover"]:not(.popover-list, .popover-waffle, .walkthrough-popover)').popover({
        html: true,
        trigger: 'focus',
        title: 'Notifications<i class="fas fa-cog"></i>'
    })
    $('.popover-list').popover({
        html: true,
        trigger: 'focus',
        title: 'Notifications<i class="fas fa-cog"></i>',
        content: '<ul>\
                <li>Fannie Woods has received your request. You will be notified soon</li>\
                <li>Dennis Wise has processed your ticket and the case is not closed</li>\
                <div class="popover-view-all"><a href="#">View All</a></div>\
                </ul>'
    })
    $('.popover-waffle').popover({
        html: true,
        trigger: 'focus',
        content: '<div class="waffle-menu">\
                <div class="row">\
                    <div class="waffle-menu-item">\
                        <div class="waffle-menu-icon mo"></div>\
                        <p>Members Only</p>\
                    </div>\
                    <div class="waffle-menu-item">\
                      <div class="waffle-menu-icon mcm"></div>\
                      <p>MyCU Manager</p>\
                  </div>\
                  <div class="waffle-menu-item">\
                      <div class="waffle-menu-icon ach"></div>\
                      <p>ACH Services</p>\
                  </div>\
                </div>\
                <div class="row">\
                  <div class="waffle-menu-item">\
                      <div class="waffle-menu-icon ms"></div>\
                      <p>Member$mart</p>\
                  </div>\
                  <div class="waffle-menu-item">\
                    <div class="waffle-menu-icon if"></div>\
                    <p>IF Dashboard</p>\
                  </div>\
                  <div class="waffle-menu-item">\
                      <div class="waffle-menu-icon scd"></div>\
                      <p>SimpliCD*</p>\
                  </div>\
                </div>\
                <div class="row">\
                  <div class="waffle-menu-item">\
                      <div class="waffle-menu-icon tz"></div>\
                      <p>TranzCapture</p>\
                  </div>\
                  <div class="waffle-menu-item">\
                    <div class="waffle-menu-icon od"></div>\
                    <p>OneWire Domestic</p>\
                  </div>\
                  <div class="waffle-menu-item">\
                      <div class="waffle-menu-icon og"></div>\
                      <p>OneWire Global</p>\
                  </div>\
                </div>\
            </div>'
    })
})


$(document).ready(function () {

    $('.btn-clear').click(function () {

        $('.form-control-search').val('');

    })

    $('.lightbox-image').click(function () {

        var slide = $(this).data('slide');

        $('.lightbox-item').removeClass('active'); //remove from all slides first

        $('.lightbox-item-' + slide).addClass('active');

    })

    $('.floating-actions > .btn').click(function () {

        $('.floating-actions > ul').toggleClass("floating-actions-visible");

    })

    $('body').scrollspy({ target: '#list-example' })

    //ACTION SHEET FUNCTIONALITY
    $('.action-toggle').click(function () {
        $(".btn-group-vertical").toggleClass("open");
    });

    $('.action-sheet .btn').click(function () {
        $(".btn-group-vertical").removeClass("open");
    })


    //DATA TABLE FUNCTIONALITY
    //$('.table').DataTable();

    //$('.previous a').replaceWith('<a href="#" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0" class="page-link">&lt;</a>');
    //$('.next a').replaceWith('<a href="#" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0" class="page-link">&gt;</a>');

    //progress circle

    $(function () {

        $(".progress").each(function () {

            var value = $(this).attr('data-value');
            var left = $(this).find('.progress-left .progress-bar');
            var right = $(this).find('.progress-right .progress-bar');

            if (value > 0) {
                if (value <= 50) {
                    right.css('transform', 'rotate(' + percentageToDegrees(value) + 'deg)')
                } else {
                    right.css('transform', 'rotate(180deg)')
                    left.css('transform', 'rotate(' + percentageToDegrees(value - 50) + 'deg)')
                }
            }

        })

        function percentageToDegrees(percentage) {

            return percentage / 100 * 360

        }

    });

    //progress circle end

    // Rotate Floating Actions Btn
    $('.floating-actions .btn-open').click(function () {

        var btn = $(this);

        // if btn does NOT already have rotate-clockwise class
        if (!btn.hasClass('rotate-clockwise')) {

            // check if has counter-clockwise class. If so, remove it
            if (btn.hasClass('rotate-counter-clockwise')) {
                btn.removeClass('rotate-counter-clockwise');
            }
            // add rotate-clockwise class
            btn.addClass('rotate-clockwise');
        } else {
            // if it has rotate-clockwise class remove it, and add rotate-counter-clockwise class
            btn.removeClass('rotate-clockwise').addClass('rotate-counter-clockwise');

        }
    });

    //DROP DOWN SEARCH FILTER
    $('.dropdown-search').keyup(function () {
        var input = $(this).val().toUpperCase();
        var div = $(this).parent();
        div.children("a").each(function () {

            var link = $(this);
            var linkTxt = $(this).text().toUpperCase();

            if (linkTxt.includes(input)) {
                link.css("display", "");
            } else {
                link.css("display", "none");
            }
        });

    })
});

//DROP DOWN TAGS SEARCH FILTER
$('.dropdown-tags-search').keyup(function () {
    var input = $(this).val().toUpperCase();
    var div = $(this).next();
    div.children("a").each(function () {

        var link = $(this);
        var linkTxt = $(this).text().toUpperCase();

        if (linkTxt.includes(input)) {
            link.css("display", "");
        } else {
            link.css("display", "none");
        }
    });

});

//DROPDOWN TAGS
$('.dropdown-tags-container .dropdown-item').click(function (e) {
    e.preventDefault();
    var link = $(this);
    var linkTxt = $(this).text();
    var div = $(this).parent().parent();
    var tagList = div.find("ul");

    tagList.append('<li class="dropdown-tags-item">' + linkTxt + '<i class="fas fa-times"></i></li>');
    link.remove();
});

//clear a tag
$(document).on("click", ".dropdown-tags-item i", function () {
    var tag = $(this).parent();
    var txt = tag.text();
    var menu = tag.parent().parent().parent().children('.dropdown-menu');

    $(this).parent().remove();
    menu.append('<a class="dropdown-item" href="#">' + txt + '</a>');

});

// DATE PICKER
$(document).ready(function () {
    var date_input = $('input[name="date"]');
    var container = $('.bootstrap-iso form').length > 0 ? $('.bootstrap-iso form').parent() : "body";
    var options = {
        orientation: "bottom auto",
        format: 'mm/dd/yyyy',
        container: container,
        todayHighlight: true,
        autoclose: true
    };
    date_input.datepicker(options);
});

$(document).ready(function () {
    var date_input = $('input[name="startdate"]');
    var container = $('.bootstrap-iso form').length > 0 ? $('.bootstrap-iso form').parent() : "body";
    var options = {
        orientation: "bottom auto",
        format: 'mm/dd/yyyy',
        container: container,
        todayHighlight: true,
        autoclose: true
    };
    date_input.datepicker(options);
});

$(document).ready(function () {
    var date_input = $('input[name="enddate"]');
    var container = $('.bootstrap-iso form').length > 0 ? $('.bootstrap-iso form').parent() : "body";
    var options = {
        orientation: "bottom auto",
        format: 'mm/dd/yyyy',
        container: container,
        todayHighlight: true,
        autoclose: true
    };
    date_input.datepicker(options);
});

$(function () {

    //Upload functionality

    $('input[type="file"]').change(function () {
        var val = $(this).val();
        alert(val);
        $(this).siblings('label').children('span').html(val);
    });

});

// WALKTHROUGH FUNCTIONALITY 
$(document).ready(function () {

    // POPULATE POPOVERS
    $(".walkthrough-popover[tabIndex='0']").popover({
        html: true,
        content: '<div class="walkthrough">\
                    <p>Let\'s take a tour of the new and improved investment dashboard!</p>\
                    <div class="walkthrough-footer">\
                        <p class="dismiss">Dismiss</p><p class="start">Start</p>\
                    </div>\
                    </div>'
    }).popover('show');

    $(".walkthrough-popover[tabIndex='1']").popover({
        html: true,
        content: '<div class="walkthrough">\
                <span class="dismiss-times">&times</span>\
                <p class="walkthrough-content">Test. Here is a snapshot of your investment accounts at Corporate One. Listed are your balances.</p>\
                <div class="walkthrough-footer">\
                    <p class="next" data-order="1">Next</p>\
                 </div>\
            </div>'
    });

    $(".walkthrough-popover[tabIndex='2']").popover({
        html: true,
        content: '<div class="walkthrough">\
                <span class="dismiss-times">&times</span>\
                <p class="walkthrough-content">Here is a snapshot of something else in the application. The end.</p>\
                <div class="walkthrough-footer">\
                    <p class="dismiss">Dismiss</p>\
                 </div>\
            </div>'
    });

    $('.walkthrough-popover').click(function () {

        var tabIndex = $(this).attr('tabindex');
        $('.walkthrough').parent().parent().addClass('walkthrough-container');
    });


    //DISMISS WALKTHROUGH
    $(document).on('click', '.dismiss', function () {

        $(this).parent().parent().parent().parent().removeClass('show');
    });
    $(document).on('click', '.dismiss-times', function () {
        $(this).parent().parent().parent().removeClass('show');
    });

    // START WALKTHROUGH
    $(document).on('click', '.start', function () {
        $(".walkthrough-popover[tabIndex='0']").popover('hide');
        $(".walkthrough-popover[tabIndex='1']").popover('show');
    });

    // NAV THROUGH WALKTHROUGH
    var tabIndex = 1;

    $(document).on('click', '.next', function () {
        $(".walkthrough-popover[tabIndex='" + tabIndex + "']").popover('hide');

        tabIndex = (tabIndex + 1);

        $(".walkthrough-popover[tabIndex='" + tabIndex + "']").popover('show');
    });


});


function newFunction() {
    return 'show';
}

//SCROLLING/DRAGGABLE TABS//

$(document).ready(function () {

    //Left/Right Arrows
    $(".left-arrow").click(function () {
        event.preventDefault();
        $('#myTab').animate({
            scrollLeft: "-=200px"
        }, "slow");
    });

    $(".right-arrow").click(function () {
        event.preventDefault();
        $('#myTab').animate({
            scrollLeft: "+=200px"
        }, "slow");
    });

    $('#myTab').scroll(function () {
        var $width = $('#myTab').outerWidth()
        var $scrollWidth = $('#myTab')[0].scrollWidth;
        var $scrollLeft = $('#myTab').scrollLeft();

        var diff = Math.floor($scrollWidth - $width);
        var left = Math.floor($scrollLeft);

        if (left >= diff) {
            $('.right-arrow').hide('100');
        }
        else {
            $('.right-arrow').show('100');
        }
        if ($scrollLeft === 0) {
            $(".left-arrow").removeClass('hidden').hide('100');
        }
        else {
            $(".left-arrow").removeClass('hidden').show('100');
        }
    });

    //Scrolling to active tab
    var $menu = $('.scrolling-tabs');

    $('.scrolling-tabs-wrapper .nav-link[href^="#"]').on('click', function (e) {
        e.preventDefault();
        var $element = $(this);

        $menu.find('a').removeClass('current');
        $element.addClass('current');

        var elOffset = $element.offset().left;
        var elWidth = $element.outerWidth(true);
        var menuScrollLeft = $menu.scrollLeft();
        var menuWidth = $menu.width();

        var myScrollPos = elOffset + elWidth / 2 + menuScrollLeft - menuWidth / 2;
        $menu.scrollLeft(myScrollPos).scrollIntoView({ behavior: "smooth", inline: "center" });

        $('.nav-tabs').scrollingTabs({
            disableScrollArrowsOnFullyScrolled: true

        });

        document.getElementById('myTab').scrollIntoView({ behavior: 'smooth' });
    });

    //Draggable
    const slider = document.querySelector('.scrolling-tabs');

    if (slider != null || slider != undefined) {

        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', e => {
            isDown = true;
            e.preventDefault();
            slider.classList.add('current');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('current');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('current');
        });
        slider.addEventListener('mousemove', e => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 1;
            slider.scrollLeft = scrollLeft - walk;
            console.log(walk);
        });

    };

    $('.nav-link').attr('draggable', 'false'); //Added draggable attribute
});

//Add Scrolling Tabs for small screens
$(document).ready(function () {

    $(window).on('resize', function () {
        var width = $(window).width();
        if (width >= 200 && width <= 1007) {

            $('.nav-tabs').addClass('scrolling-tabs');
            $('#tabSet').addClass('scrolling-tabs-wrapper');
            $('.nav-tabs').removeClass('justified');
            $('.mask').removeClass('hide');
        } else {
            $('.nav-tabs').removeClass('scrolling-tabs');
            $('#tabSet').removeClass('scrolling-tabs-wrapper');
            $('.nav-tabs').addClass('justified');
            $('.mask').addClass('hide');
        }
    });

});


$(document).ready(function () {
    $('.member-login a').attr('target', 'blank'); //Force to oepn blank tab

    //Waffle Menu
    $('.waffle-menu-btn, .waffle-menu-label').on('click', function (e) {
        $('.waffle-menu').toggleClass('show'); // Hide & Show
    });

    //Click outside to close the modal
    $(document).click(function (event) {
        if (!$(event.target).closest(".waffle-menu, .waffle-menu-btn, .waffle-menu-label").length) {
            $("body").find(".waffle-menu").removeClass("show");
        }
    });
});

$(document).ready(function () {
    if ($("#homeBreadcrumbs .site-alert-layout").length > 0) {
        $(".row.bottom-to-top.mx-auto").first().css("margin-top", "0");
    }
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    $(".site-alerts .site-alert").each(function () {
        var $alert = $(this);
        var $dismiss = $alert.find(".site-alert-dismiss > button");
        var $collapse = $alert.find(".site-alert-collapse > button");

        if ($alert.hasClass("collapsed")) {
            $alert.find("a").attr("tabindex", "-1");
        }

        $dismiss.on("click", function () {
            $alert.slideUp(250);
            var alertGuid = $alert.data("alertguid");
            setCookie(alertGuid, "Dismissed", 365); // store for 1 year
        });

        $collapse.on("click", function () {
            var alertGuid = $alert.data("alertguid");

            if ($(this).attr("aria-expanded") === "false") {
                $(this).attr("aria-expanded", "true");
                $alert.removeClass("collapsed").find(".site-alert-content").attr("aria-hidden", "false");
                $alert.find("a").attr("tabindex", "0");
                setCookie(alertGuid, "Collapsable", 365);
            } else {
                $(this).attr("aria-expanded", "false");
                $alert.addClass("collapsed").find(".site-alert-content").attr("aria-hidden", "true");
                $alert.find("a").attr("tabindex", "-1");
                setCookie(alertGuid, "Collapsed", 365);
            }
        });
    });

});

/* === Trigger Member Hero Rotator Enhancement ===
 * Enhances elements with class 'trigger-member' by:
 * 1. Adding p-1 to nearest col-* ancestor
 * 2. Adding pt-1 to enclosing .row
 * 3. Wrapping that row in a div.mx-auto (max-width:1480px) if not already wrapped
 * 4. Idempotent & observes dynamically added content
 */
(function () {
    var COL_REGEX = /\bcol-(?:auto|\d+|xs-\d+|sm-\d+|md-\d+|lg-\d+|xl-\d+|xxl-\d+)\b/;
    var PROCESSED_ATTR = 'data-trigger-processed';
    var WRAPPER_ATTR = 'data-trigger-wrapper';
    var OBS_MARK = '__triggerMemberObserver';
    var MAX_WIDTH = '1480px';

    function findFirstColumn(el) {
        var cur = el ? el.parentElement : null;
        while (cur && cur !== document.body) {
            if (COL_REGEX.test(cur.className)) return cur;
            cur = cur.parentElement;
        }
        return null;
    }

    function ensureWrapper(row) {
        if (!row) return;
        var parent = row.parentElement;
        if (!parent) return;
        // Already marked wrapper
        if (parent.hasAttribute(WRAPPER_ATTR)) return;
        // Parent already suitable wrapper
        if (parent.classList.contains('mx-auto') && parent.style.maxWidth.replace(/\s+/g, '') === MAX_WIDTH) {
            parent.setAttribute(WRAPPER_ATTR, '1');
            return;
        }
        var wrapper = document.createElement('div');
        wrapper.className = 'mx-auto';
        wrapper.style.maxWidth = MAX_WIDTH;
        wrapper.setAttribute(WRAPPER_ATTR, '1');
        parent.insertBefore(wrapper, row);
        wrapper.appendChild(row);
    }

    function enhance(el, force) {
        if (!el) return;
        if (!force && el.getAttribute(PROCESSED_ATTR) === '1') return;
        el.setAttribute(PROCESSED_ATTR, '1');

        var col = findFirstColumn(el);
        if (col) col.classList.add('p-1');

        var row = col ? col.closest('.row') : el.closest('.row');
        if (row) {
            row.classList.add('pt-1');
            ensureWrapper(row);
        }
    }

    function runAll(options) {
        var force = options && options.force;
        document.querySelectorAll('.trigger-member').forEach(function (el) { enhance(el, force); });
    }

    function observe() {
        if (window[OBS_MARK]) return; // prevent duplicate observers
        var observer = new MutationObserver(function (muts) {
            muts.forEach(function (m) {
                m.addedNodes.forEach(function (n) {
                    if (n.nodeType !== 1) return;
                    if (n.classList && n.classList.contains('trigger-member')) enhance(n);
                    if (n.querySelectorAll) {
                        n.querySelectorAll('.trigger-member').forEach(function (inner) { enhance(inner); });
                    }
                });
            });
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
        window[OBS_MARK] = observer;
    }

    // Expose minimal API for debugging
    window.corpOne = window.corpOne || {};
    window.corpOne.triggerMember = window.corpOne.triggerMember || {};
    window.corpOne.triggerMember.run = function () { runAll(); };
    window.corpOne.triggerMember.forceRun = function () { runAll({ force: true }); };
    window.corpOne.triggerMember.disconnect = function () { if (window[OBS_MARK]) { window[OBS_MARK].disconnect(); delete window[OBS_MARK]; } };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { runAll(); observe(); });
    } else {
        runAll();
        observe();
    }
})();
// === End Trigger Member Hero Rotator Enhancement ===


/* === Custom Text Block Enhancement ===
 * For each element with class 'custom-text':
 * 1. Find its closest parent div.fr-view and enforce height:100%
 * 2. Find the immediate parent column (expects class 'col-lg-4') and add class 'p-1'
 * 3. Idempotent; processes dynamically added nodes via MutationObserver
 */
(function () {
    var PROCESSED_ATTR = 'data-customtext-processed';
    var OBS_MARK = '__customTextObserver';

    function enhance(el, force) {
        if (!el) return;
        if (!force && el.getAttribute(PROCESSED_ATTR) === '1') return;

        var fr = el.closest('.fr-view');
        if (fr) {
            // Preserve existing inline styles while ensuring height:100%
            if (fr.style.height !== '100%') {
                fr.style.height = '100%';
            }
        }

        // According to provided structure, fr-view's parent is the column
        var columnCandidate = fr ? fr.parentElement : el.parentElement;
        if (columnCandidate && columnCandidate.classList && columnCandidate.classList.contains('col-lg-4')) {
            columnCandidate.classList.add('p-1');
        }

        el.setAttribute(PROCESSED_ATTR, '1');
    }

    function runAll(options) {
        var force = options && options.force;
        document.querySelectorAll('.custom-text').forEach(function (el) { enhance(el, force); });
    }

    function observe() {
        if (window[OBS_MARK]) return;
        var observer = new MutationObserver(function (muts) {
            muts.forEach(function (m) {
                m.addedNodes.forEach(function (n) {
                    if (n.nodeType !== 1) return;
                    if (n.classList && n.classList.contains('custom-text')) {
                        enhance(n);
                    }
                    if (n.querySelectorAll) {
                        n.querySelectorAll('.custom-text').forEach(function (inner) { enhance(inner); });
                    }
                });
            });
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
        window[OBS_MARK] = observer;
    }

    // Expose minimal API for debugging
    window.corpOne = window.corpOne || {};
    window.corpOne.customText = window.corpOne.customText || {};
    window.corpOne.customText.run = function () { runAll(); };
    window.corpOne.customText.forceRun = function () { runAll({ force: true }); };
    window.corpOne.customText.disconnect = function () {
        if (window[OBS_MARK]) {
            window[OBS_MARK].disconnect();
            delete window[OBS_MARK];
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { runAll(); observe(); });
    } else {
        runAll();
        observe();
    }
})();
// === End Custom Text Block Enhancement ===

$(document).ready(function () {
    $('#ratesPrintDiv').hide();
    $('#backBtn, .print-button-wrapper').hide();
});

function showOnlyPrintDiv() {
    $(this).hide();
    $('#ratesPrintDiv').show().addClass('active');
    $('#tabSet').hide();
    $('#backBtn').show();

    $('.rates-section, #tabRates, #layoutHeader, .bottom-to-top, .subscribe-container, .navbar-hamburger-icon').hide();
}

function backToInit() {
    $('#ratesPrintDiv').hide().removeClass('active');
    $('#backBtn, .print-button-wrapper').hide();


    $('.rates-section, #tabRates, #tabSet, #layoutHeader, .bottom-to-top, .subscribe-container, .navbar-hamburger-icon').show();
}